/**
 * Copyright 2016 Taito United Oy
 * All rights reserved.
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from 'react-intl';

// Styles
import './styles/AuthHeader.scss';

const propTypes = {
  fetchAuthenticationForms: PropTypes.func.isRequired,
  authenticationForms: PropTypes.array,
};

class AuthHeader extends PureComponent {
  state = {
    ssnPrompt: false,
    ssnDisabled: false,
    ssn: '',
  };

  getAuthenticationForms() {
    const forms = this.props.authenticationForms.map(form => (
      <form
        action="https://sign.visma.net/external/entry"
        style={{ marginLeft: '5px', textAlign: 'center' }}
        className="pure-form pure-form-stacked"
        method="post"
      >
        {Object.keys(form).map(key => (
          <input type="hidden" name={key} value={form[key]} />
        ))}

        <input type="image" src={`https://sign.visma.net/${form.image}`} />
      </form>
    ));

    return (
      <div
        styleName="auth-required"
        style={{ flexDirection: 'column', marginTop: '10px' }}
      >
        <div style={{ marginBottom: '30px' }}>
          <FormattedMessage
            id="authHeader.label.select"
            description="Auth header label for selecting verification method"
            defaultMessage="Select your verification method"
          />
        </div>

        <div
          style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}
        >
          {forms}
        </div>
      </div>
    );
  }

  _enterSSN = event => {
    event.preventDefault();
    this.setState({ ssnPrompt: true });
  };

  _fetchAuthenticationForms = event => {
    event.preventDefault();

    const { ssn } = this.state;
    const redirectUri = window.location.href;

    this.props.fetchAuthenticationForms({ ssn, redirect_uri: redirectUri });
    this.setState({ ssnDisabled: true });
  };

  _onSSNChange = event => {
    this.setState({ ssn: event.target.value });
  };

  render() {
    return (
      <div styleName="AuthHeader">
        <div styleName="auth-required">
          <i styleName="info-icon" className="fa fa-info-circle" />
          <div styleName="info-text">
            <FormattedMessage
              id="authHeader.text"
              description="Auth header text"
              defaultMessage={
                'Muokataksesi yrityksesi tietoja ja nähdäksesi ' +
                'chat-historiasi sinun täytyy tunnistautua ' +
                'verkkopankkitunnuksilla'
              }
            />
          </div>

          {!this.state.ssnPrompt && (
            <button onClick={this._enterSSN} styleName="auth-btn">
              <FormattedMessage
                id="authHeader.button"
                description="Auth header button"
                defaultMessage="Tunnistaudu verkkopankkitunnuksilla"
              />
            </button>
          )}

          {this.state.ssnPrompt && (
            <form
              style={{ marginLeft: '5px', textAlign: 'center' }}
              className="pure-form pure-form-stacked"
              onSubmit={this._fetchAuthenticationForms}
            >
              <label>
                <FormattedMessage
                  id="authHeader.form.ssn"
                  description="Auth header form SSN label"
                  defaultMessage="Social security number"
                />
              </label>
              <input
                onChange={this._onSSNChange}
                value={this.state.ssn}
                disabled={this.state.ssnDisabled}
                className="pure-input-1"
                type="text"
              />

              <button
                type="button"
                disabled={this.state.ssnDisabled}
                onClick={this._fetchAuthenticationForms}
                className="pure-button pure-button-primary"
              >
                <FormattedMessage
                  id="authHeader.form.button"
                  description="Auth header form button"
                  defaultMessage="Tunnistaudu"
                />
              </button>
            </form>
          )}
        </div>

        {this.props.authenticationForms.length
          ? this.getAuthenticationForms()
          : null}
      </div>
    );
  }
}

AuthHeader.propTypes = propTypes;

export default AuthHeader;
